import React from 'react';
import styled from 'styled-components';
import { BodyFour } from '../styles/theme/default/typography';

const Wrapper = styled.div`
  margin-top: 1px;
  margin-bottom: 12px;
`;

const FinalSaleMessage = ({ color }) => {
  return (
    <Wrapper>
      <BodyFour color={color}>Final Sale: no returns or exchanges</BodyFour>
    </Wrapper>
  );
};

export default FinalSaleMessage;
